export const VIDFLEET_MAINTENANCE_WARNINGS_REQUEST = "VIDFLEET_MAINTENANCE_WARNINGS_REQUEST"
export const VIDFLEET_MAINTENANCE_WARNINGS_RESULT = "VIDFLEET_MAINTENANCE_WARNINGS_RESULT";

export const VIDFLEET_MAINTENANCE_SET_LIST = "VIDFLEET_MAINTENANCE_SET_LIST";